import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { useHomeSwitchStore } from "src/store/homeSwitch.store";
import { ProductSection } from "../components";
import Ranking from "../components/Ranking";
import { IpSelectSection } from "./index";
import useGetHomeIpSelect from "./queries/useGetHomeIpSelect";
/**
 * 섹션 타입별 렌더러
 */ const renderSection = (section, index, homeId)=>{
    switch(section.sectionType){
        case "brand_ranking":
            // 모든 카테고리에 브랜드 데이터가 있어야 렌더링
            const allCategoriesHaveBrands = Object.values(section.content.brandsByCategory).every((brands)=>brands.length > 0);
            if (!allCategoriesHaveBrands) return;
            return /*#__PURE__*/ _jsx(Ranking, {
                data: section.content,
                className: "my-10 max-sm:my-6"
            }, index);
        case "handout_curation":
            if (!section.content.products.length) return;
            var _section_content_imageUrl, _section_content_header, _section_content_ctaButtonLink, _section_content_ctaButtonName;
            return /*#__PURE__*/ _jsx(ProductSection, {
                title: section.content.title,
                titleImageUrl: (_section_content_imageUrl = section.content.imageUrl) !== null && _section_content_imageUrl !== void 0 ? _section_content_imageUrl : "",
                header: (_section_content_header = section.content.header) !== null && _section_content_header !== void 0 ? _section_content_header : "",
                ctaButtonLink: (_section_content_ctaButtonLink = section.content.ctaButtonLink) !== null && _section_content_ctaButtonLink !== void 0 ? _section_content_ctaButtonLink : "",
                ctaButtonName: (_section_content_ctaButtonName = section.content.ctaButtonName) !== null && _section_content_ctaButtonName !== void 0 ? _section_content_ctaButtonName : "",
                products: section.content.products,
                homeId: homeId,
                trackingEventName: "[Home] Handout Curation Section Clicked"
            }, index);
        case "new_handout":
            if (!section.content.products.length) return;
            var _section_content_imageUrl1, _section_content_header1, _section_content_ctaButtonLink1, _section_content_ctaButtonName1;
            return /*#__PURE__*/ _jsx(ProductSection, {
                title: section.content.title,
                titleImageUrl: (_section_content_imageUrl1 = section.content.imageUrl) !== null && _section_content_imageUrl1 !== void 0 ? _section_content_imageUrl1 : "",
                header: (_section_content_header1 = section.content.header) !== null && _section_content_header1 !== void 0 ? _section_content_header1 : "",
                ctaButtonLink: (_section_content_ctaButtonLink1 = section.content.ctaButtonLink) !== null && _section_content_ctaButtonLink1 !== void 0 ? _section_content_ctaButtonLink1 : "",
                ctaButtonName: (_section_content_ctaButtonName1 = section.content.ctaButtonName) !== null && _section_content_ctaButtonName1 !== void 0 ? _section_content_ctaButtonName1 : "",
                products: section.content.products,
                homeId: homeId,
                trackingEventName: "[Home] New Handout Section Clicked"
            }, index);
        default:
            return null;
    }
};
/**
 * IP Select 컨테이너 컴포넌트
 *
 * 역할:
 * 1. IpSelectSection (필터 + 선택된 교재 카드) 렌더링
 * 2. getHomeIpSelect API 호출 (sourceId 기반)
 * 3. 하위 섹션 렌더링 (sections 배열 순서대로)
 *
 * 데이터 흐름:
 * - selectedBook.sourceId로 useGetHomeIpSelect 호출
 * - 응답의 sections 배열을 순회하며 각 섹션 렌더링
 */ const IpSelectContainer = (param)=>{
    let { data , selectedBook , onSelectSource , isLoading , isDefaultSelected  } = param;
    var _ipSelectData_sections;
    const homeId = useHomeSwitchStore((s)=>s.homeId);
    // 선택된 교재의 상세 데이터 조회
    const { data: ipSelectData  } = useGetHomeIpSelect({
        sourceId: selectedBook.sourceId,
        sourceType: selectedBook.sourceType
    });
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "relative -mx-8 px-8 pt-10 max-sm:-mx-5 max-sm:px-5 max-sm:pt-6",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "absolute inset-x-0 top-0 h-[212px] bg-blue-50 max-sm:h-[140px]"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: cn("relative mx-auto w-full max-w-[1200px]", "max-lg:px-8 max-sm:px-5"),
                        children: /*#__PURE__*/ _jsx(IpSelectSection, {
                            data: data,
                            selectedBook: ipSelectData === null || ipSelectData === void 0 ? void 0 : ipSelectData.source,
                            onSelectSource: onSelectSource,
                            isLoading: isLoading,
                            isDefaultSelected: isDefaultSelected,
                            homeId: homeId
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mx-auto w-full max-w-[1200px]",
                children: ipSelectData === null || ipSelectData === void 0 ? void 0 : (_ipSelectData_sections = ipSelectData.sections) === null || _ipSelectData_sections === void 0 ? void 0 : _ipSelectData_sections.map((section, index)=>renderSection(section, index, homeId))
            })
        ]
    });
};
export default IpSelectContainer;
